import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * A typescript & react boilerplate with api call example
 *
 * Copyright (C) 2020 Adam van der Kruk aka TacB0sS
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { _className, AppPage, Button, LL_H_C, LL_V_L, TS_ComponentTransition } from '@nu-art/thunderstorm-frontend/index';
import { Component_GoogleSAMLLogin, Component_Login, Component_Register } from '@nu-art/user-account-frontend/index';
import './Page_Login.scss';
import { ICONS } from '@app/styles';
export class Page_Login extends AppPage {
    constructor(props) {
        super(props);
        this.state = { register: false };
    }
    deriveStateFromProps(nextProps, state) {
        return state;
    }
    // ######################### Render Background #########################
    renderBackground = () => {
        return _jsxs("div", { id: 'login-background', children: [_jsx("div", { className: 'box box-1' }), _jsx("div", { className: 'box box-2' }), _jsx("div", { className: 'blur-backdrop' })] });
    };
    // ######################### Render Peeper #########################
    renderSwitchToRegister = () => {
        const className = _className('page-login__switch-to-register', this.state.register && 'hidden');
        return _jsxs(LL_V_L, { className: className, children: [_jsx("h1", { children: "New Here?" }), _jsx("h2", { children: "Sign up to use our Knowledge Manager" }), _jsx(Button, { variant: 'secondary', onClick: () => this.setState({ register: true }), children: "Sign Up" })] });
    };
    renderSwitchToLogin = () => {
        const className = _className('page-login__switch-to-login', !this.state.register && 'hidden');
        return _jsxs(LL_V_L, { className: className, children: [_jsx("h1", { children: "Already Registered?" }), _jsx("h2", { children: "Login to use our Knowledge Manager" }), _jsx(Button, { variant: 'secondary', onClick: () => this.setState({ register: false }), children: "Login" })] });
    };
    renderPeeper = () => {
        return _jsxs("div", { className: 'page-login__peeper', children: [this.renderSwitchToLogin(), this.renderSwitchToRegister()] });
    };
    // ######################### Render Login Area #########################
    renderLoginContainer = () => {
        const hidden = this.state.register;
        const className = _className('page-login__form-container', hidden && 'hidden');
        return _jsx("div", { className: className, children: _jsx(TS_ComponentTransition, { trigger: !hidden, transitionTimeout: 300, mountTimeout: 300, skipAnimationOnMount: true, children: this.renderLoginForm() }) });
    };
    renderLoginForm = () => {
        return _jsxs(LL_V_L, { className: 'page-login__login-form', children: [_jsx("h1", { children: "Login to Your Account" }), _jsx(Component_Login, {}), _jsx("div", { className: 'page-login__login-form__separator' }), _jsx(Component_GoogleSAMLLogin, { text: 'Login With Google' })] });
    };
    // ######################### Render Register Area #########################
    renderRegisterContainer = () => {
        const hidden = !this.state.register;
        const className = _className('page-login__form-container', hidden && 'hidden');
        return _jsx("div", { className: className, children: _jsx(TS_ComponentTransition, { trigger: !hidden, transitionTimeout: 300, mountTimeout: 300, skipAnimationOnMount: true, children: this.renderRegisterForm() }) });
    };
    renderRegisterForm = () => {
        return _jsxs(LL_V_L, { className: 'page-login__login-form', children: [_jsx("h1", { children: "Register Your Account" }), _jsx(Component_Register, { renderPasswordRules: true })] });
    };
    // ######################### Render #########################
    render() {
        return _jsxs(LL_H_C, { id: 'page-login', children: [this.renderBackground(), _jsxs(LL_H_C, { className: 'match_parent', children: [this.renderLoginContainer(), this.renderPeeper(), this.renderRegisterContainer()] }), this.renderQuaiBanner()] });
    }
    renderQuaiBanner = () => {
        return _jsxs(LL_H_C, { className: 'page-login__quai-banner', children: [_jsx(ICONS.quai.component, { className: 'quai-icon' }), _jsxs(LL_V_L, { className: 'header', children: [_jsx("div", { className: 'header__title', children: "Knowledge" }), _jsx("div", { className: 'header__sub-title', children: "Manager" })] })] });
    };
}
